import React, { useCallback, useEffect, useState } from 'react';
import Accordion from '../../components/common/Accordian';
import EditIcon from '../../assets/EditIcon';

import SunIcon from '../../assets/SunIcon';
import BusCard from '../../components/common/BusCard';

import { IOperationalBusDetail } from '../../interfaces/operationBusDetail';
import {
  IBusPickupAllocationDto,
  IPaxDriverAllocation,
} from '../../interfaces/driverPaxAllocation';
import { encodeDateForUrl, getAdjustedDate } from '../../utils/dateUtils';
import driverAllocationAPI from '../../api/driverAllocationAPI';
import { AllocationsPax, DateSelector } from '../../components';
import { IDriverAllocation } from '../../interfaces/driverAllocationReq';
import useLocationStore from '../../store/locatonStore';
import ReusableButton from '../../components/common/Button/Button';
import CrossIcon from '../../assets/CrossIcon';
import CheckIcon from '../../assets/CheckIcon';
import { translate } from '../../i18n';
import { toast } from 'react-toastify';
import useTemperatureStore from '../../store/temperatureStore';
import Loader from '../../assets/loader/Loader';
import { locationConstant } from '../../constants/constant';
import useDateStore from '../../store/selectedDateStore';
import { ISelectedBusData } from '../../interfaces/selectedBusData';
import { IOriginalAllocation } from '../../interfaces/originalBusAllocation';
import useBgColorStore from '../../store/bgColor';
import CalendarHeader from '../../components/common/Header/CalenderHeader';
import SunIconDark from '../../assets/SunIconDark';
import EditIconDark from '../../assets/EditIconDark';
import { showOrReplaceToast } from '../../utils/utility';
import CrossIconDarkForm from '../../assets/icon/CrossIconForm';

const DropOffMobile = () => {
  const { selectedDateFromStore, setSelectedDateFromStore } = useDateStore();
  const { bgColor, updateBgColor } = useBgColorStore();
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const { selectedTemperature } = useTemperatureStore();
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );
  const [operationBus, setOperationBus] = useState<IOperationalBusDetail[]>();
  const [bookings, setBookings] = useState<IPaxDriverAllocation[]>();
  const [selectedBuses, setSelectedBuses] = useState<{
    [key: string]: ISelectedBusData;
  }>({});
  const [busPax, setBusPax] = useState<{
    [key: string]: number;
  }>({
    totalPax: 0,
    totalAllocatedPax: 0,
  });
  const [editModeMap, setEditModeMap] = useState<{ [key: string]: boolean }>(
    {},
  );
  const [originalAllocations, setOriginalAllocations] = useState<{
    [bookingId: string]: IOriginalAllocation[];
  }>({});
  const [busAllocations, setBusAllocations] = useState<{
    [operationStaffId: string]: number;
  }>({});

  const [realTimeBusPax, setRealTimeBusPax] = useState<{
    [key: string]: number;
  }>({
    totalPax: 0,
    totalAllocatedPax: 0,
  });
  const [unallocatedPax, setUnallocatedPax] = useState<
    IPaxDriverAllocation[] | null
  >();

  const getPickupAllocationDetails = useCallback(
    async (date: Date, ownerId: number, isShowLoader?: boolean) => {
      const encodedDate = encodeDateForUrl(date);
      try {
        setIsPageLoading(isShowLoader ?? false);
        const response = await driverAllocationAPI.getDriverDropOffAllocation(
          ownerId,
          encodedDate,
        );
        console.log(response?.data);

        setOperationBus(response?.data?.operationDetails?.busDetails);
        setBookings(response?.data?.bookings);
        setBusPax({
          totalPax: response?.data?.totalPax ?? 0,
          totalAllocatedPax:
            response?.data?.operationDetails?.totalAllocatedPax ?? 0,
        });
        onSetUnallocatedPax(response?.data?.bookings);
        // Initialize selectedBuses and originalAllocations
        const initialSelectedBuses: { [key: string]: ISelectedBusData } = {};
        const initialOriginalAllocations: {
          [key: string]: IOriginalAllocation[];
        } = {};

        response?.data.bookings.forEach((booking: IPaxDriverAllocation) => {
          const bookingIdString = String(booking.bookingId);
          const bookingProductTripIdStr = String(booking.bookingProductTripId);
          const bookingIdStr = `${bookingIdString}_${bookingProductTripIdStr}`;


          // Initialize arrays if needed
          if (!initialOriginalAllocations[bookingIdStr]) {
            initialOriginalAllocations[bookingIdStr] = [];
          }

          if (!initialSelectedBuses[bookingIdStr]) {
            initialSelectedBuses[bookingIdStr] = {
              bookingProductTripPickupId: booking.bookingProductTripDropOffId,
              bookingId: booking.bookingId,
              paxNo: booking.paxNo,
              allocNo: booking.allocPax,
              allocations: [],
            };
          }

          // Handle array of allocations
          booking.busPickupAllocation?.forEach(
            (allocation: IBusPickupAllocationDto) => {
              if (allocation.operationStaffId) {
                // Add to original allocations
                initialOriginalAllocations[bookingIdStr].push({
                  operationStaffId: allocation.operationStaffId,
                  busAllocationId: allocation?.busAllocationId,
                  paxNo: Number(allocation.paxNo || booking.allocPax),
                });

                // Add to selected buses
                initialSelectedBuses[bookingIdStr].allocations.push({
                  operationStaffId: allocation.operationStaffId,
                  busAllocationId: allocation?.busAllocationId,
                  oldOperationStaffId: allocation.operationStaffId,
                  splitPax: Number(allocation.paxNo || booking.allocPax),
                  isDeleted: false,
                });
              }
            },
          );

          // If no allocations were found, remove the entry
          if (initialSelectedBuses[bookingIdStr].allocations.length === 0) {
            delete initialSelectedBuses[bookingIdStr];
          }
        });
        // set value
        setOriginalAllocations(initialOriginalAllocations);
        setSelectedBuses(initialSelectedBuses);
      } catch (error) {
        console.error('Error fetching allocation details:', error);
      } finally {
        setIsPageLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
      setSelectedDate(selectedDateFromStore);
    }, [selectedDateFromStore]);
    
  useEffect(() => {
    getPickupAllocationDetails(selectedDate, selectedLocation.OwnerId, true);
  }, [selectedDate, getPickupAllocationDetails, selectedLocation]);

  const onSetUnallocatedPax = (bookings: IPaxDriverAllocation[]) => {
    const unallocated = bookings?.filter((booking: IPaxDriverAllocation) => {
      return booking?.busPickupAllocation?.length === 0;
    });

    setUnallocatedPax(unallocated);
  };

  const allocatedBus = async (booking: IPaxDriverAllocation) => {
    try {
      const selectedBusDetails = selectedBuses[`${booking?.bookingId}_${booking?.bookingProductTripId}`];
      if (!selectedBusDetails) {
        console.log('No bus selected for booking', booking); //TODO: I will remove this
        return;
      }
      if (Object.keys(selectedBusDetails).length === 0) return;

      const payload = (selectedBusDetails?.allocations || [])
        .filter((allocation) => {
          const original =
            originalAllocations[
              `${booking?.bookingId}_${booking?.bookingProductTripId}`
            ] || [];
          const originalAlloc = original.find(
            (orig) =>
              String(orig.operationStaffId) ===
              String(allocation.operationStaffId),
          );

          return (
            allocation.isDeleted ||
            !originalAlloc ||
            originalAlloc.paxNo !== allocation.splitPax
          );
        })
        .filter((allocation) => {
          if (allocation.isDeleted) return true;
          return (
            allocation.splitPax !== undefined &&
            allocation.splitPax !== null &&
            allocation.splitPax > 0
          );
        })
        .map((allocation) => ({
          bookingProductTripPickupId: Number(
            selectedBusDetails.bookingProductTripPickupId,
          ),
          bookingId: Number(selectedBusDetails.bookingId),
          operationStaffId: Number(allocation.operationStaffId),
          paxNo: allocation.splitPax,
          ...(allocation.busAllocationId && {
            busAllocationId: Number(allocation.busAllocationId),
          }),
          ...(allocation.oldOperationStaffId && {
            oldOperationStaffId: Number(allocation.oldOperationStaffId),
          }),
          isDeleted: allocation.isDeleted || false,
        }));

      setIsLoading(true);

      if (payload.length > 0) {
        console.log('allocations payload:', payload); //TODO: I will remove this in next PR
        const response =
          await driverAllocationAPI.addDriverDropOffAllocation(payload);
        console.log('Response:', response?.data); // I will remove this in next PR
        showOrReplaceToast(
          'operations',
          translate('busAllocation.successMessage.allocationSave'),
          'success',
        );
        await getPickupAllocationDetails(
          selectedDate,
          selectedLocation.OwnerId,
        );

        setEditModeMap((prev) => ({
          ...prev,
          [`${booking?.bookingId}_${booking?.bookingProductTripId}`]: false,
        }));
      } else {
        console.log('No changes detected in allocations');
      }
    } catch (error) {
      console.error('Error fetching allocation details:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const updateBooking = (
    bookingId: number,
    busAllocationId: number,
    operationStaffId: number,
  ) => {
    const updatedBooking = bookings?.map((value) =>
      bookingId === value?.bookingId
        ? {
            ...value,
            busAllocationId: busAllocationId,
            allocPax: value?.allocPax,
            operationStaffId: operationStaffId,
          }
        : value,
    );
    setBookings(updatedBooking ? updatedBooking : bookings);
  };

  const updateBusOperationPax = (
    operationStaffId: number | string,
    paxNo: number,
    oldOperationStaffId: number,
  ) => {
    const updatedOperationBus = operationBus?.map((value) =>
      operationStaffId === value?.operationStaffId
        ? { ...value, allocatedPax: paxNo + value?.allocatedPax }
        : oldOperationStaffId === value?.operationStaffId
          ? { ...value, allocatedPax: value?.allocatedPax - paxNo }
          : value,
    );
    setOperationBus(updatedOperationBus);
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
      setSelectedDateFromStore(date);
    }
  };

  // Toggle Edit Mode for a specific accordion

  const handleCheckboxChange = (
    bookingId: string | number,
    operationStaffId: string | number,
    busAllocationId: string | number | null,
    bookingProductTripPickupId: string | number,
    paxNo: string | number,
    oldOperationStaffId: string | number | null,
    bookingProductTripId: string | number,
  ) => {
    const bookingIdStr = `${bookingId}_${bookingProductTripId}`;
    const operationStaffIdStr = String(operationStaffId);

    setSelectedBuses((prev) => {
      const currentBooking = prev[bookingIdStr];
      // Check if this is an original allocation
      const isOriginalAllocation = originalAllocations[bookingIdStr]?.some(
        (orig) => String(orig.operationStaffId) === operationStaffIdStr,
      );

      if (!currentBooking) {
        // First selection for this booking - set full pax count since it's the only allocation
        return {
          ...prev,
          [bookingIdStr]: {
            bookingProductTripPickupId,
            bookingId,
            paxNo,
            allocNo: Number(paxNo), // Set allocNo to full pax count
            allocations: [
              {
                operationStaffId,
                busAllocationId,
                oldOperationStaffId,
                splitPax: Number(paxNo), // Set initial splitPax to full pax count
                isDeleted: false,
              },
            ],
          },
        };
      }

      // Check if this bus is already in allocations (active or deleted)
      const existingAllocationIndex = currentBooking.allocations.findIndex(
        (a) => String(a.operationStaffId) === operationStaffIdStr,
      );

      if (
        existingAllocationIndex !== -1 &&
        currentBooking.allocations[existingAllocationIndex].isDeleted
      ) {
        // This is a previously deleted allocation that should be reactivated
        const updatedAllocations = [...currentBooking.allocations];
        const activeAllocations = updatedAllocations.filter(
          (a, idx) => idx !== existingAllocationIndex && !a.isDeleted,
        );

        // If there are no other active allocations, give this one the full pax count
        const splitPax = activeAllocations.length === 0 ? Number(paxNo) : 0;

        updatedAllocations[existingAllocationIndex] = {
          ...updatedAllocations[existingAllocationIndex],
          isDeleted: false,
          splitPax,
        };

        return {
          ...prev,
          [bookingIdStr]: {
            ...currentBooking,
            allocations: updatedAllocations,
            allocNo: activeAllocations.reduce(
              (sum, a) => sum + (a.splitPax || 0),
              splitPax,
            ),
          },
        };
      }

      if (
        existingAllocationIndex !== -1 &&
        !currentBooking.allocations[existingAllocationIndex].isDeleted
      ) {
        // Bus is already selected - handle unselection
        if (isOriginalAllocation) {
          // For originally allocated buses, mark for deletion instead of removing
          const updatedAllocations = currentBooking.allocations.map(
            (alloc, index) =>
              index === existingAllocationIndex
                ? { ...alloc, isDeleted: true }
                : alloc,
          );

          // Find active allocations (not marked for deletion)
          const activeAllocations = updatedAllocations.filter(
            (a) => !a.isDeleted,
          );

          // Calculate total allocated pax from active allocations
          let totalAllocated = activeAllocations.reduce(
            (sum, alloc) => sum + (alloc.splitPax || 0),
            0,
          );

          // If only one allocation remains active, give it the full pax count
          if (activeAllocations.length === 1) {
            const remainingAllocationIndex = updatedAllocations.findIndex(
              (a) => !a.isDeleted,
            );
            if (remainingAllocationIndex !== -1) {
              updatedAllocations[remainingAllocationIndex].splitPax =
                Number(paxNo);
              totalAllocated = Number(paxNo);
            }
          }

          return {
            ...prev,
            [bookingIdStr]: {
              ...currentBooking,
              allocations: updatedAllocations,
              allocNo: totalAllocated,
            },
          };
        } else {
          // For new allocations, remove them entirely
          const newAllocations = currentBooking.allocations.filter(
            (_, index) => index !== existingAllocationIndex,
          );

          if (newAllocations.length === 0) {
            const newSelected = { ...prev };
            delete newSelected[bookingIdStr];
            return newSelected;
          }

          // Calculate total allocated pax from remaining allocations
          let totalAllocated = newAllocations.reduce(
            (sum, alloc) => sum + (alloc.splitPax || 0),
            0,
          );

          // If only one allocation remains, give it the full pax count
          if (newAllocations.length === 1) {
            newAllocations[0].splitPax = Number(paxNo);
            totalAllocated = Number(paxNo);
          }

          return {
            ...prev,
            [bookingIdStr]: {
              ...currentBooking,
              allocations: newAllocations,
              allocNo: totalAllocated,
            },
          };
        }
      }

      // Add new bus allocation
      const activeAllocations = currentBooking.allocations.filter(
        (a) => !a.isDeleted,
      );
      const splitPax = activeAllocations.length === 0 ? Number(paxNo) : 0;

      const newAllocation = {
        operationStaffId,
        busAllocationId,
        oldOperationStaffId: null,
        splitPax,
        isDeleted: false,
      };

      const newAllocations = [...currentBooking.allocations, newAllocation];
      const totalAllocated = newAllocations
        .filter((a) => !a.isDeleted)
        .reduce((sum, alloc) => sum + (alloc.splitPax || 0), 0);

      return {
        ...prev,
        [bookingIdStr]: {
          ...currentBooking,
          allocations: newAllocations,
          allocNo: totalAllocated,
        },
      };
    });
  };

  // update  the toggleEditMode function to reset values when canceling edits
  const onToggleEditMode = (id: number, bookingProductTripId:number) => {
    const originalBusAllocs: { [operationStaffId: string]: number } = {};
    operationBus?.forEach((bus) => {
      originalBusAllocs[bus.operationStaffId] = bus.allocatedPax || 0;
    });
    setBusAllocations(originalBusAllocs);

    // Restore original busPax count
    setRealTimeBusPax({
      totalPax: busPax?.totalPax ?? 0,
      totalAllocatedPax: busPax?.totalAllocatedPax ?? 0,
    });

    // Reset selectedBuses to original state
    const initialSelectedBuses: { [key: string]: ISelectedBusData } = {};
    const initialOriginalAllocations: { [key: string]: IOriginalAllocation[] } =
      {};

    bookings?.forEach((booking) => {
      const bookingIdString = String(booking.bookingId);
      const bookingProductTripIdStr = String(booking?.bookingProductTripId);
      const bookingIdStr = `${bookingIdString}_${bookingProductTripIdStr}`;

      if (!initialOriginalAllocations[bookingIdStr]) {
        initialOriginalAllocations[bookingIdStr] = [];
      }

      if (!initialSelectedBuses[bookingIdStr]) {
        initialSelectedBuses[bookingIdStr] = {
          bookingProductTripPickupId: booking.bookingProductTripDropOffId,
          bookingId: booking.bookingId,
          paxNo: booking.paxNo,
          allocNo: booking.allocPax,
          allocations: [],
        };
      }

      booking.busPickupAllocation?.forEach((allocation) => {
        if (allocation.operationStaffId) {
          initialOriginalAllocations[bookingIdStr].push({
            operationStaffId: allocation.operationStaffId,
            busAllocationId: allocation?.busAllocationId,
            paxNo: Number(allocation.paxNo || booking.allocPax),
          });

          initialSelectedBuses[bookingIdStr].allocations.push({
            operationStaffId: allocation.operationStaffId,
            busAllocationId: allocation?.busAllocationId,
            oldOperationStaffId: allocation.operationStaffId,
            splitPax: Number(allocation.paxNo || booking.allocPax),
            isDeleted: false,
          });
        }
      });

      if (initialSelectedBuses[bookingIdStr].allocations.length === 0) {
        delete initialSelectedBuses[bookingIdStr];
      }
    });

    setOriginalAllocations(initialOriginalAllocations);
    setSelectedBuses(initialSelectedBuses);
    setEditModeMap((prev) => ({
      ...prev,
      [`${id}_${bookingProductTripId}`]: !prev[`${id}_${bookingProductTripId}`], // Toggle the specific accordion's edit mode
    }));
  };

  // Cancel edit mode for a specific accordion
  const cancelEditMode = (bookingId: number, bookingProductTripId:number) => {
    // Reset to original state of allocations
    const originalBusAllocs: { [operationStaffId: string]: number } = {};
    operationBus?.forEach((bus: IOperationalBusDetail) => {
      originalBusAllocs[bus.operationStaffId] = bus.allocatedPax || 0;
    });
    setBusAllocations(originalBusAllocs);

    setRealTimeBusPax({
      totalPax: busPax?.totalPax ?? 0,
      totalAllocatedPax: busPax?.totalAllocatedPax ?? 0,
    });

    // Reset selected buses
    const initialSelectedBuses: { [key: string]: ISelectedBusData } = {};
    const initialOriginalAllocations: { [key: string]: IOriginalAllocation[] } =
      {};

    bookings?.forEach((booking) => {
      const bookingIdString = String(booking.bookingId);
      const bookingProductTripIdStr = String(booking?.bookingProductTripId);
      const bookingIdStr = `${bookingIdString}_${bookingProductTripIdStr}`;

      if (!initialOriginalAllocations[bookingIdStr]) {
        initialOriginalAllocations[bookingIdStr] = [];
      }

      if (!initialSelectedBuses[bookingIdStr]) {
        initialSelectedBuses[bookingIdStr] = {
          bookingProductTripPickupId: booking.bookingProductTripDropOffId,
          bookingId: booking.bookingId,
          paxNo: booking.paxNo,
          allocNo: booking.allocPax,
          allocations: [],
        };
      }

      booking.busPickupAllocation?.forEach((allocation) => {
        if (allocation.operationStaffId) {
          initialOriginalAllocations[bookingIdStr].push({
            operationStaffId: allocation.operationStaffId,
            busAllocationId: allocation?.busAllocationId,
            paxNo: Number(allocation.paxNo || booking.allocPax),
          });

          initialSelectedBuses[bookingIdStr].allocations.push({
            operationStaffId: allocation.operationStaffId,
            busAllocationId: allocation?.busAllocationId,
            oldOperationStaffId: allocation.operationStaffId,
            splitPax: Number(allocation.paxNo || booking.allocPax),
            isDeleted: false,
          });
        }
      });

      if (initialSelectedBuses[bookingIdStr].allocations.length === 0) {
        delete initialSelectedBuses[bookingIdStr];
      }
    });

    setOriginalAllocations(initialOriginalAllocations);
    setSelectedBuses(initialSelectedBuses);
    setEditModeMap((prev) => ({
      ...prev,
      [`${bookingId}_${bookingProductTripId}`]: false, // Turn off edit mode
    }));
  };

  // update ealTimeBusPax values and busAllocations
  useEffect(() => {
    if (operationBus && busPax) {
      setRealTimeBusPax({
        totalPax: busPax?.totalPax ?? 0,
        totalAllocatedPax: busPax?.totalAllocatedPax ?? 0,
      });

      // Initialize bus-specific allocation counts
      const initialBusAllocs: { [operationStaffId: string]: number } = {};
      operationBus?.forEach((bus) => {
        initialBusAllocs[bus.operationStaffId] = bus.allocatedPax || 0;
      });
      setBusAllocations(initialBusAllocs);
    }
  }, [operationBus, busPax]);

  //calculate and update allocation stats based on changes
  const updateAllocationStats = useCallback(() => {
    // Calculate bus-specific allocations
    const newBusAllocations: { [operationStaffId: string]: number } = {};
    operationBus?.forEach((bus) => {
      newBusAllocations[bus.operationStaffId] = 0;
    });

    // Calculate total allocated pax and bus-specific allocations
    let totalAllocatedPax = 0;

    Object.values(selectedBuses).forEach((booking) => {
      booking.allocations.forEach((allocation) => {
        if (!allocation.isDeleted) {
          const busId = allocation.operationStaffId.toString();
          const paxCount = allocation.splitPax;

          if (newBusAllocations[busId] !== undefined) {
            newBusAllocations[busId] += paxCount;
            totalAllocatedPax += paxCount;
          }
        }
      });
    });

    // Include original allocations that are not in selectedBuses
    bookings?.forEach((booking) => {
      // Skip if this booking is in our selectedBuses (already counted)
      if (
        selectedBuses[`${booking?.bookingId}_${booking?.bookingProductTripId}`]
      )
        return;

      // Add all original allocations from bookings not in selectedBuses
      booking.busPickupAllocation?.forEach((allocation) => {
        if (allocation.operationStaffId) {
          const busId = allocation.operationStaffId.toString();
          const paxCount = Number(allocation.paxNo || booking.allocPax);

          if (newBusAllocations[busId] !== undefined) {
            newBusAllocations[busId] += paxCount;
            totalAllocatedPax += paxCount;
          }
        }
      });
    });

    // Update the state with new allocations
    setBusAllocations(newBusAllocations);
    setRealTimeBusPax((prev) => ({
      ...prev,
      totalAllocatedPax,
    }));
  }, [selectedBuses, operationBus, bookings]);

  // Call this function whenever selectedBuses changes
  useEffect(() => {
    updateAllocationStats();
  }, [selectedBuses, updateAllocationStats]);

  const handlePaxCountChange = (
    bookingId: string | number,
    operationStaffId: string | number,
    newPaxCount: string,
    bookingProductTripId: string | number,
  ) => {
    const bookingIdStr = `${bookingId}_${bookingProductTripId}`;
    const operationStaffIdStr = String(operationStaffId);
    const numPaxCount = parseInt(newPaxCount) || 0;

    setSelectedBuses((prev) => {
      const currentBooking = prev[bookingIdStr];
      if (!currentBooking) return prev;

      const totalPax = Number(currentBooking.paxNo);

      // Create a copy of the allocations
      const updatedAllocations = [...currentBooking.allocations];

      // Find the index of the current allocation being modified
      const currentAllocationIndex = updatedAllocations.findIndex(
        (a) =>
          String(a.operationStaffId) === operationStaffIdStr && !a.isDeleted,
      );

      if (currentAllocationIndex === -1) return prev;

      // Update only the current allocation with the new pax count
      updatedAllocations[currentAllocationIndex] = {
        ...updatedAllocations[currentAllocationIndex],
        splitPax: numPaxCount,
      };

      // Recalculate total pax
      const totalAllocated = updatedAllocations.reduce((sum, alloc) => {
        return !alloc.isDeleted
          ? sum + (parseInt(alloc.splitPax as any) || 0)
          : sum;
      }, 0);

      return {
        ...prev,
        [bookingIdStr]: {
          ...currentBooking,
          allocations: updatedAllocations,
          allocNo: totalAllocated,
        },
      };
    });
  };

  return (
    <div className={`w-full bg-background h-max `}>
      <div className={`bg-background`}>
        <div className="mt-2 bg-backgroundColor-white">
          <CalendarHeader />
        </div>
        <div className="flex items-start pl-4 pr-4 pt-4">
          <span className="font-semibold text-base text-textColor">
            {translate('dropOffScreen.busAllocationHeading')}
          </span>
        </div>
        <div className=" bg-backgroundColor-white  pl-4 pr-4 pt-4 ">
          <div
            className={`h-[44px]  p-2 rounded flex items-center justify-center ${bgColor}`}
          >
            <DateSelector
              onDateChange={handleDateChange}
              initialDate={selectedDate}
              showArrows={true}
              className="w-[50%]"
            />
          </div>
        </div>

        <div className={`${bgColor} p-4 mt-4`}>
          <div>
            <AllocationsPax<IPaxDriverAllocation>
              message={translate('busAllocation.incorrectAllocation')}
              heading={translate('busAllocation.incorrectAllocation')}
              data={unallocatedPax ? unallocatedPax : []}
              totalPax={busPax?.totalPax}
              totalAllocatedPax={realTimeBusPax['totalAllocatedPax']}
            />
          </div>
          <div className="text-textColorGray text-sm font-medium mb-2 mt-4 flex items-center justify-between bg-backgroundColor-white h-[44px]">
            <span className="text-text-primary font-normal ml-4 text-[14px]">
              {translate('common.bus')}
            </span>
            <span className="text-text-primary font-normal mr-4 text-[14px]">
              <span className="text-textColor">
                {realTimeBusPax['totalAllocatedPax']}
              </span>
              /{busPax['totalPax']}
            </span>
          </div>
        </div>
      </div>

      <div
        className={`sticky top-12 z-10  ${operationBus?.length === 0 ? 'hidden' : 'grid'} grid-cols-2 gap-4 mt-4 p-4 ${bgColor}`}
      >
        {operationBus?.map((bus) => (
          <>
            <BusCard
              busName={bus?.busName}
              capacity={bus?.capacity}
              allocatedPax={busAllocations[bus?.operationStaffId]}
              bgColor={`bg-background`}
              initials={bus?.initials}
              balloon={bus?.balloon}
            />
          </>
        ))}
      </div>
      <div className={`${bgColor}`}>
        <div className={`mt-4 p-6 ${bookings?.length === 0 ? 'h-screen' : ''}`}>
          {isPageLoading ? (
            <div className="inline-grid">
              <Loader width={50} height={50} />
            </div>
          ) : bookings?.length === 0 ? (
            <div className="text-text-primary flex justify-center items-center h-80 text-lg font-medium">
              {translate('flightAllocation.noData')}
            </div>
          ) : (
            bookings?.map((booking) => {
              const bookingIdStr = `${booking.bookingId}_${booking.bookingProductTripId}`;

              const paxAllocatedCount =
                selectedBuses[bookingIdStr] &&
                selectedBuses[bookingIdStr]?.allocations?.filter(
                  (a) => !a.isDeleted,
                )?.length > 0
                  ? selectedBuses[bookingIdStr]?.allocNo
                  : 0;
              return (
                <>
                  <Accordion
                    title={`${booking?.paxName}: ${booking?.male}/${booking?.female}/${booking?.children}:${booking?.paxNo}`}
                    icon={
                      <div>
                        <div className="block dark:hidden">
                          <EditIcon />
                        </div>
                        <div className="hidden dark:block">
                          <EditIconDark />
                        </div>
                      </div>
                    }
                    bgColor="bg-backgroundColor-white"
                    onToggleEditMode={onToggleEditMode}
                    bookingId={booking?.bookingId}
                    bookingProductTripId={booking?.bookingProductTripId}
                    status={`${booking?.status}`}
                  >
                    <div className="bg-backgroundColor-white">
                      <div className="grid grid-cols-2 gap-y-2 text-sm text-textColorGray text-left">
                        <div>
                          <p className="font-medium">
                            {translate('allocation.Pickup')}:
                          </p>
                          <p>{booking?.pickup}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('allocation.dropOff')}:
                          </p>
                          <p>{booking?.dropOff}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('allocation.id')}:
                          </p>
                          <p>{booking?.bookingId}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('busAllocation.luggage')}:
                          </p>
                          <p>
                            {booking?.luggage
                              ? `${translate('common.yes')}`
                              : ``}
                          </p>
                        </div>
                        <div className="col-span-2">
                          <p className="font-medium">
                            {translate('allocation.comment')}:
                          </p>
                          <p>{booking?.comment}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('allocation.tour')}:
                          </p>
                          <p>{booking?.productName}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('allocation.agent')}:
                          </p>
                          <p>{booking?.agentName}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('busAllocation.balloon')}:
                          </p>
                          <p>{booking?.allocBalloon?.toString()}</p>
                        </div>
                        <div>
                          <p className="font-medium">
                            {translate('allocation.flight')}:
                          </p>
                          <p>{booking?.flightNo}</p>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-2 mt-4 text-left">
                        <div
                          className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
                        >
                          <p className="font-medium text-textColorGray ">
                            {translate('busAllocation.allocated')}
                          </p>
                          {/* <p>{booking?.allocPax}</p> TODO: I will remove this in next PR */}
                          <p
                            className={`${paxAllocatedCount === 0 ? 'text-text-red' : 'text-text-green'}`}
                          >
                            {paxAllocatedCount}
                          </p>
                        </div>
                        <div
                          className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
                        >
                          <p className="font-medium text-textColorGray">
                            {translate('allocation.flight')}
                          </p>
                          <p className="text-text-primary">
                            {booking?.flightNo}
                          </p>
                        </div>
                        <div
                          className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
                        >
                          <p className="font-medium text-textColorGray">
                            {translate('allocation.pax')}
                          </p>
                          <p className="text-text-primary">
                            {booking?.allocPax}
                          </p>
                        </div>
                      </div>
                      <div className="space-y-2 mt-4">
                        {operationBus?.map((bus) => {
                          return (
                            <label
                              key={bus.busId}
                              className="flex items-center space-x-2 cursor-pointer text-text-busCardColor"
                            >
                              <input
                                disabled={
                                  !editModeMap[
                                    `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                  ]
                                }
                                type="checkbox"
                                className="w-5 h-5 text-text-busCardColor border-gray-300 rounded focus:ring-blue-500"
                                checked={
                                  // First check if this bus is selected in our state
                                  selectedBuses[
                                    `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                  ]?.allocations.some(
                                    (a) =>
                                      String(a.operationStaffId) ===
                                        String(bus.operationStaffId) &&
                                      !a.isDeleted,
                                  ) ||
                                  // Or if it's in the original allocation but not yet in our state
                                  (!selectedBuses[
                                    `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                  ] &&
                                    booking.busPickupAllocation?.some(
                                      (allocation) =>
                                        String(allocation.operationStaffId) ===
                                        String(bus.operationStaffId),
                                    ))
                                }
                                onChange={() => {
                                  // Find the existing allocation if any
                                  const existingAllocation =
                                    booking.busPickupAllocation?.find(
                                      (allocation) =>
                                        String(allocation.operationStaffId) ===
                                        String(bus.operationStaffId),
                                    );

                                  handleCheckboxChange(
                                    booking.bookingId,
                                    bus.operationStaffId,
                                    existingAllocation?.busAllocationId || null,
                                    booking.bookingProductTripDropOffId,
                                    booking.paxNo,
                                    existingAllocation?.operationStaffId ||
                                      null,
                                    booking.bookingProductTripId,
                                  );
                                }}
                              />
                              <span className="">{bus?.busName}</span>
                              {editModeMap[
                                `${booking?.bookingId}_${booking?.bookingProductTripId}`
                              ] &&
                                selectedBuses[
                                  `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                ]?.allocations.filter((a) => !a.isDeleted)
                                  .length > 1 &&
                                selectedBuses[
                                  `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                ]?.allocations.some(
                                  (a) =>
                                    String(a.operationStaffId) ===
                                      String(bus.operationStaffId) &&
                                    !a.isDeleted,
                                ) && (
                                  <input
                                    type="number"
                                    min="0"
                                    max={Number(booking.paxNo)}
                                    value={
                                      selectedBuses[
                                        `${booking?.bookingId}_${booking?.bookingProductTripId}`
                                      ]?.allocations.find(
                                        (a) =>
                                          String(a.operationStaffId) ===
                                            String(bus.operationStaffId) &&
                                          !a.isDeleted,
                                      )?.splitPax || ''
                                    }
                                    onChange={(e) =>
                                      handlePaxCountChange(
                                        booking.bookingId,
                                        bus.operationStaffId,
                                        e.target.value,
                                        booking.bookingProductTripId,
                                      )
                                    }
                                    className="w-16 h-8 border rounded px-2 text-black"
                                    placeholder="Pax"
                                  />
                                )}
                            </label>
                          );
                        })}
                      </div>
                      {editModeMap[
                        `${booking?.bookingId}_${booking?.bookingProductTripId}`
                      ] && (
                        <div className="flex space-x-4 mt-4">
                          <ReusableButton
                            variant="secondary"
                            children={translate('common.cancel')}
                            icon={
                              <div>
                                <div className="block dark:hidden">
                                  <CrossIcon />
                                </div>
                                <div className="hidden dark:block">
                                  <CrossIconDarkForm />
                                </div>
                              </div>
                            }
                            className="w-full bg-button-cancelButtonBgColor text-text-cancelButtonTextColor"
                            onClick={() =>
                              cancelEditMode(
                                booking?.bookingId,
                                booking?.bookingProductTripId,
                              )
                            }
                          />
                          <ReusableButton
                            icon={<CheckIcon />}
                            children={translate('common.confirm')}
                            variant="primary"
                            className="w-full"
                            onClick={() => allocatedBus(booking)}
                            isLoader={isLoading}
                          />
                        </div>
                      )}
                    </div>
                  </Accordion>
                </>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default DropOffMobile;
